<div class="placeholder__container">
  <h2>
    {{ placeholderText || "placeholders.no_data" | translate }}
  </h2>
  <ion-icon [name]="icon || 'ban-outline'" class="placeholder__icon"></ion-icon>
</div>
